export function getSafariMajorVersion(): number | null {
    if (typeof navigator === "undefined") return null;
    const match = navigator.userAgent.match(/Version\/(\d+)/);
    return match ? parseInt(match[1], 10) : null;
}
